// Training and Competence Tracker: the routes and the sidebar rows of `wealth.compliance.tc-tracker` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.tc-tracker',
    routes: [
        {
            frontend: 'comply',
            path: 'tc-tracker',
            lazy: () => import('@/pages/comply/tc-tracker/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'tc-tracker',
            label: 'T&C Tracker',
            href: '/comply/tc-tracker',
            icon: 'GraduationCap',
            group: 'governance',
            order: 1180,
            wip: true,
        },
    ],
});
